import React from 'react';
import FeedbackPage from '@pedidosya/web-fenix/system/FeedbackPage';
import FooterButton from '@pedidosya/web-fenix/system/FooterButton';
import { getWindow } from '@app/shared/utils/window';
import { WebViewEvents } from '@app/shared/config/webViewEvents';
import { useLinkContext } from '@app/shared/contexts/LinkProvider';
import useIsWebView from '@app/shared/hooks/useIsWebView';

export const Error404 = () => {
  const isWebView = useIsWebView();
  const { emitEvent } = useLinkContext();

  const action = () => {
    const wn = getWindow();
    if (isWebView) {
      return emitEvent(WebViewEvents.CLOSE);
    }

    wn.location.href = '/';
  };

  return (
    <FeedbackPage
      variant="empty"
      title="Esta página no existe"
      description="Es posible que el link sea incorrecto o que se haya eliminado la página."
    >
      <FeedbackPage.TopBar left="icon" right="icon" middle="empty" onGoBack={action} />
      <FeedbackPage.FooterButton>
        <FooterButton.Button
          fullWidth
          hierarchy="primary"
          label="Ir al inicio"
          onClick={action}
          size="large"
        />
      </FeedbackPage.FooterButton>
    </FeedbackPage>
  );
};
